// extracted by mini-css-extract-plugin
export default {"blockClose":"styles_blockClose__K2GLx"};